<ng-container>
  <ngx-spinner class="spinner">
    <ng-container>
      <img
        src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/v7.5/loading-v75.gif"
        width="80px"
        height="80px"
        class="spinner-image"
        alt=""
      />
    </ng-container>
  </ngx-spinner>
</ng-container>
